import React, { useState } from "react";
// import AuthContext from "../../../Auth/AuthContext";
// import axios from "axios";
// import BASE_URL from "../../../API/api";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import Footer from "../../layouts/footer/Footer";
import SelectAmount from "./SelectAmount";
import SelectPaymentMethod from "./SelectPaymentMethod";
import DepositAmountRequest from "./DepositAmountRequest";
import StickyHeader from "../../../layouts/Header/Header";
import Sidebar from "../../../layouts/Header/Sidebar";
import EWallet from "./EWallet";
import Voucher from "./Voucher";

function DepositStatic() {
  const [activeStep, setActiveStep] = useState("step1");
  const [selectedAmount, setSelectedAmount] = useState(""); // 🟣 Add this line
  const [paymentSelectedMethod, setPaymentSelectedMethod] = useState(""); // 🟣 Add this line
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [depositFormData, setDepositFormData] = useState({
    amount: "", // selected in Step 1
    paymentSelectedMethod: "", // selected in Step 2
    utr_number: "",
    payment_screenshot: null,
  });

  const steps = [
    {
      id: "step1",
      icon: "fas fa-folder-open",
      title: "EFT",
      content: () => (
        <SelectAmount
          amount={selectedAmount}
          setAmount={setSelectedAmount}
          count={4}
          paymentSelectedMethod={paymentSelectedMethod}
          setPaymentSelectedMethod={setPaymentSelectedMethod}
          formData={depositFormData}
          setFormData={setDepositFormData}
        />
      ),
    },
    {
      id: "step2",
      icon: "fas fa-briefcase",
      title: "E-Wallet",
      content: () => (
        <EWallet
          amount={selectedAmount}
          setAmount={setSelectedAmount}
          count={4}
          paymentSelectedMethod={paymentSelectedMethod}
          setPaymentSelectedMethod={setPaymentSelectedMethod}
          formData={depositFormData}
          setFormData={setDepositFormData}
        />
      ),
    },
    {
      id: "step3",
      icon: "fas fa-star",
      title: "Voucher",
      content: () => (
        <Voucher
          amount={selectedAmount}
          setAmount={setSelectedAmount}
          count={4}
          paymentSelectedMethod={paymentSelectedMethod}
          setPaymentSelectedMethod={setPaymentSelectedMethod}
          formData={depositFormData}
          setFormData={setDepositFormData}
        />
      ), // 🟣 Pass amount here
    },
  ];

  const goNext = () => {
    const currentIndex = steps.findIndex((step) => step.id === activeStep);
    if (currentIndex < steps.length - 1) {
      setActiveStep(steps[currentIndex + 1].id);
    }
  };

  const goPrevious = () => {
    const currentIndex = steps.findIndex((step) => step.id === activeStep);
    if (currentIndex > 0) {
      setActiveStep(steps[currentIndex - 1].id);
    }
  };
  return (
    <>
      {/* header  */}
      <StickyHeader onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      {/* header end */}
      <div className={`container-fluid page-body-wrapper ${isSidebarOpen ? "sidebar-icon-only" : ""}`}>
        {/* Sidebar Nav Starts */}
        <Sidebar isSidebarOpen={isSidebarOpen} />
        {/* Sidebar Nav Ends */}
        {/* 🔍 Search Bar */}

        <div className="main-panel">
          <div className="content-wrapper">
            <div className="max-1250 mx-auto">
              <div className="h-100">
                <div className="pt-3 pb-2">
                  <div className="row px-2">
                    <div>DDD</div>
                    {/* header Starts */}
                    <div className="d-flex align-items-center justify-content-between position-relative  px-0">
                      {/* Centered Title */}
                      <h5 className="position-absolute start-50 translate-middle-x m-0 text-white fs-16">
                        Deposit
                      </h5>
                    </div>

                    {/* Wizard */}
                    <div className="container mt-4 px-0">
                      <div className="wizard my-5 px-2">
                        <ul className="nav nav-tabs justify-content-center">
                          {steps.map((step) => (
                            <li
                              key={step.id}
                              className="nav-item flex-fill"
                              role="presentation"
                            >
                              <span
                                className="text-white position-absolute start-50 translate-middle-x"
                                style={{ top: "-30px" }}
                              >
                                {step.title}
                              </span>
                              <a
                                href={`#${step.id}`}
                                className={`nav-link rounded-circle mx-auto d-flex align-items-center justify-content-center ${
                                  activeStep === step.id ? "active" : ""
                                }`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  setActiveStep(step.id); // ✅ no checks, always switch
                                }}
                              >
                                <i className={step.icon} />
                              </a>
                            </li>
                          ))}
                        </ul>

                        {/* Single Tab Content (keep just this one) */}
                       <div className="tab-content">
  {steps.map((step, index) => {
    const isActive = activeStep === step.id;

    const hasBack = index > 0;
    const hasNext = index < steps.length - 1;

    const justifyClass = hasBack && hasNext
      ? "justify-content-between"
      : hasNext
      ? "justify-content-end"     // only Continue → right end
      : "justify-content-start";  // only Back → left start

    const nextDisabled =
      (step.id === "step1" && !selectedAmount) ||
      (step.id === "step2" && !paymentSelectedMethod);

    return (
      <div
        key={step.id}
        className={`tab-pane fade ${isActive ? "show active" : ""}`}
        id={step.id}
      >
        {step.content()}

        <div className={`d-flex ${justifyClass} mt-3`}>
          {hasBack && (
            <button className="btn btn-secondary previous" onClick={goPrevious}>
              <i className="fas fa-angle-left" /> Back
            </button>
          )}

          {hasNext && (
            <button
              className="btn btn-light next"
              onClick={goNext}
              disabled={nextDisabled}
            >
              Continue <i className="fas fa-angle-right" />
            </button>
          )}
        </div>
      </div>
    );
  })}
</div>
                        {/* end .tab-content */}
                      </div>
                    </div>
                    {/* end wizard */}
                    {/* <Footer /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DepositStatic;